import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, distinctUntilChanged, filter, map, Observable, switchMap } from 'rxjs';
import { Order } from '@us/web/shared/data-access';
import { selectOrder } from '@us/web/orders/data-access';
import { TranslocoModule } from '@ngneat/transloco';
import { IonicModule } from '@ionic/angular';
import { TuiLoaderModule } from '@taiga-ui/core';
import { RouterUtil, RouteUtil } from '@us/web/shared/utils';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { RouteService } from '@us/web/shops/feature';
import { LetDirective } from '@ngrx/component';
import { BreadcrumbsComponent } from '@us/web/shared/ui';

@Component({
    selector: 'us-order-tracking',
    standalone: true,
    imports: [TranslocoModule, IonicModule, NgIf, AsyncPipe, TuiLoaderModule, LetDirective, BreadcrumbsComponent],
    templateUrl: './order-tracking.page.html',
    styleUrls: ['./order-tracking.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTrackingPage {
    private readonly route = inject(ActivatedRoute);
    private readonly store = inject(Store);
    protected readonly routeService = inject(RouteService);

    readonly homePageUrl$ = this.routeService.homePageUrl$;

    private readonly orderIdParams$: Observable<string> = this.route.params.pipe(
        map(params => params[RouterUtil.Cog.OrderId]),
        filter(tuiIsPresent),
        distinctUntilChanged()
    );

    readonly order$: Observable<Order | null> = this.orderIdParams$.pipe(
        switchMap(orderId => this.store.select(selectOrder(orderId)))
    );

    readonly orderDetailUrl$ = this.orderIdParams$.pipe(map(orderId => RouteUtil.getOrderRouteUrl(orderId)));

    readonly isLoadingMap$ = new BehaviorSubject(true);

    readonly RouteUtil = RouteUtil;

    onLoadMap() {
        this.isLoadingMap$.next(false);
    }
}
